<div class="timeline-wrapper">
  <s2a-pure-timeline
    [valueRetrieved]="valueRetrieved"
    [timelineGroups]="timelineGroups"
    [loadingPaginatedData]="loadingPaginatedData"
    (filteredTimeline)="onFilterTimeline($event)"
    (timelineClicked)="onStatusUpdate($event)"
    (switchReadStatus)="onSwitchReadStatus($event)"
    (applyFilterOptions)="onApplyFilter($event)"
    (fetchPaginatedData)="fetchMore()"
  ></s2a-pure-timeline>
</div>
